export default __webpack_public_path__ + "static/ezv-gsg-logo-e56a6bc18da6c33aa03c0e7bdd3c5b79.jpg";